module.exports = __webpack_public_path__ + "static/img/netpc.73c00fa6.svg";